import create from "zustand";

export type ClassroomTileSize = "sm" | "md" | "lg";

export interface ClassroomLayoutStore {
	tileSize: ClassroomTileSize;
	setTileSize: (theme: ClassroomTileSize) => void;
}

/**
 * Store for classroom layout settings, such as tile size.
 */
export const useClassroomLayoutStore = create<ClassroomLayoutStore>((set) => ({
	tileSize: "md",
	setTileSize: (tileSize) => {
		set(() => ({ tileSize: tileSize }));
	},
}));
